module.exports = __webpack_public_path__ + "assets/img/title.0e6c1d2d.png";